import { TokenStorage } from './token-storage';
import { clearCookies, getCookie, removeCookie, setCookie } from '../../../shared/utils/cookie.utils';

export class CookieStorage extends TokenStorage {

  lifespan: number;

  constructor(lifespan: number) {
    super();
    this.lifespan = lifespan;
  }

  getItem(name: string): string {
    return getCookie(name);
  }

  removeItem(name: string): void {
    removeCookie(name);
  }

  setItem(name: string, value: string): void {
    setCookie(name, value, this.lifespan);
  }

  clear(): void {
    clearCookies();
  }
}
